import { useNavigate } from "react-router-dom";
import BtnStandardLanding from "../../../../ds/BtnStandardLanding/BtnStandardLanding";
import BoldTextLanding from "../../../atoms/LandingText/BoldtextLanding";
import LightTextLanding from "../../../atoms/LandingText/LightTextLanding";
import { useLogoutMutation } from "../../../../hooks/auth";
import { useContent, useLanguages } from "../../../../hooks/content";
import { Returntext } from "../../../../pages/Landings/common/returnText";
import { ReactComponent as LogoutIcon } from "../../../../icons/log-out.svg";
import { ReactComponent as ArrowIcon } from "../../../../icons/landing/common/burger/arrow.svg";
import LanguageBtn from "../../../atoms/LanguageBtn/LanguageBtn";
import NavbarLanding from "../../../molecules/NavbarLanding/NavbarLanding";
import HeaderLogoAuthed from "../../../atoms/Logo/HeaderLogoAuthed";

const BurgerAuthed = ({
  data,
  showNavbarButtons = false,
  setBurgerShow,
  navHidden,
  burgerShow,
}) => {
  const navigate = useNavigate();
  const { mutate: logout } = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/sign-in";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const showBurger = () => {
    setBurgerShow(!burgerShow);
  };

  return (
    <>
      <div className="burger_menu">
        <header
          className={
            navHidden ? "header_container2 hidden" : "header_container2"
          }
        >
          <HeaderLogoAuthed />
          <NavbarLanding />
          {/* web view */}
          <div className="buttonDivs">
            <LanguageBtn />
            <BtnStandardLanding
              mode="active"
              txt={Returntext(contentManagementData, "navbar_btn", lang)}
              disabled={false}
              size={"standard"}
              icon={false}
              mainColor={"green"}
              onClick={() => navigate("/sign-in")}
            />
          </div>
          {/* mobile view */}

          <div className="burger_bar">
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "50px",
                width: "60px",
              }}
              onClick={showBurger}
            >
              <img
                alt=""
                src="/images/icons/landing/common/burger.svg"
                width={"20px"}
                height={"20px"}
              />
            </div>
          </div>
        </header>

        {data.item1 && (
          <BurgerContainer
            name={Returntext(contentManagementData, "accountNav", lang)}
            data={data.item1}
            setBurgerShow={setBurgerShow}
          />
        )}
        {data.item2 && (
          <BurgerContainer
            name={Returntext(contentManagementData, "DirectoryNav", lang)}
            data={data.item2}
            setBurgerShow={setBurgerShow}
          />
        )}
        {data.item3 && (
          <BurgerContainer
            name={Returntext(contentManagementData, "DirectoryNav", lang)}
            data={data.item3}
            setBurgerShow={setBurgerShow}
          />
        )}
        {data.item5 && (
          <BurgerContainer
            name={Returntext(contentManagementData, "langNav", lang)}
            data={data.item5}
            setBurgerShow={setBurgerShow}
          />
        )}
        {showNavbarButtons ? (
          <div
            style={{
              display: "flex",
              marginTop: "5%",
              padding: "0 24px",
            }}
          >
            <BtnStandardLanding
              mode="active"
              txt={Returntext(contentManagementData, "signOut", lang)}
              disabled={false}
              size={"standard"}
              icon={true}
              iconPosition={"left"}
              svg={<LogoutIcon />} // Use the SVG component here
              mainColor={"grayBorder"}
              styles={{
                width: "100%",
                backgroundColor: "#FFFDFA",
                marginBottom: "64px",
              }}
              onClick={handleLogout}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default BurgerAuthed;

function BurgerContainer({ name, data, setBurgerShow }) {
  return (
    <div className="burger_menu_cont">
      <BoldTextLanding text={name} text_color="#000000" text_size="16px" />
      {data.map((item, index) => (
        <BurgerItem key={index} item={item} setBurgerShow={setBurgerShow} />
      ))}
    </div>
  );
}
function BurgerItem({ item, setBurgerShow }) {
  const navigate = useNavigate();
  return (
    <div
      className="burger_menu_item"
      onClick={() => {
        if (item.link) {
          navigate(item.link);
          setBurgerShow(false);
        }
      }}
    >
      <div className="burger_menu_item_child">
        {item.image ? item.image : item.component}

        <LightTextLanding
          text={item.name}
          text_color="#000000"
          text_size="14px"
        />
      </div>
      <ArrowIcon className="lang-icon" /> {/* Use the SVG component here */}
    </div>
  );
}
